"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var sizes = {
  verticalSize: {
    fullHeight: {
      height: '100%'
    },
    xs: {
      height: '320px'
    },
    s: {
      height: '492px'
    },
    m: {
      height: '640px'
    },
    l: {
      height: '768px'
    },
    xl: {
      height: '960px'
    }
  }
};
var _default = exports.default = sizes;